import GoogleMapReact from "google-map-react";
import { useEffect, useState } from "react";
import MapMarkerIcon from "mdi-react/MapMarkerIcon";
import Geocode from "react-geocode";
import axios from "axios";
import { BlurWrapperWithSpan } from "../../Utils/CustomComponent";
import urls from "../../Utils/urls";

const AnyReactComponent = ({ text }) => (
  <div
    className="text-primary"
    style={{
      fontSize: "1.2em",
      width: "250px",
      position: "absolute",
      transform: "translate(-50%,-50%)",
    }}
  >
    <BlurWrapperWithSpan>
      <MapMarkerIcon color="red" size={"2em"} />{" "}
      <b className="d-block">{text}</b>
    </BlurWrapperWithSpan>
  </div>
);

export default function GoogleMapContainerV2({ address }) {
  const zoom = 17;
  const [ActualProps, setActualProps] = useState(null);
  const [apiKey, setApiKey] = useState(null);

  const headers = {
    "x-api-key": "12kXk3Xiou6Z50k0HSFZ5D8CScq2w6xJ",
  };

  useEffect(() => {
    async function getAPiKey() {
      try {
        const res = await axios.get(
          urls.dashboard.getMapsKey,
          // "https://api.loanlinq.com/api/v1/protected/get_maps_key",
          { headers }
        );
        Geocode.setApiKey(res.data.key);
        setApiKey(res.data.key);
      } catch (error) {
        console.error(error, "error");
      }
    }
    getAPiKey();
  }, []);

  useEffect(() => {
    Geocode.fromAddress(address).then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        setActualProps({
          center: {
            lat: lat,
            lng: lng,
          },
          zoom: zoom,
        });
      },
      (error) => {
        console.error(error);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiKey]);

  return (
    // Important! Always set the container height explicitly
    <div
      style={{
        height: "33vw",
        width: "100%",
        maxHeight: "350px",
        maxWidth: "1080px",
        margin: "auto",
      }}
    >
      {ActualProps && apiKey !== null ? (
        <BlurWrapperWithSpan>
          <GoogleMapReact
            bootstrapURLKeys={{ key: apiKey }}
            // defaultCenter={defaultProps.center}
            center={ActualProps.center}
            yesIWantToUseGoogleMapApiInternals
            zoom={ActualProps.zoom}
            // defaultZoom={defaultProps.zoom}
          >
            <AnyReactComponent
              lat={ActualProps.center.lat}
              lng={ActualProps.center.lng}
              text={address}
            />
          </GoogleMapReact>
        </BlurWrapperWithSpan>
      ) : null}
    </div>
  );
}
